import { useContext, useEffect, useRef, useState } from "react";
import { SettlementVendorOpeningBalancesDto } from "../../../../dtos/documents/SettlementVendorOpeningBalances/SettlementVendorOpeningBalancesDto";
import { FormProvider, useForm } from "react-hook-form";
import { NewDocumentModalViewContext } from "../../../Shared/NewDocumentModalView";
import { DocumentModalViewHeader } from "../../../Shared/DocumentModalViewHeader";
import { SettlementVendorOpeningBalancesModel } from "../../../../models/Documents/SettlementVendorOpeningBalances/SettlementVendorOpeningBalancesModel";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { importFromExcel } from "../../../../helpers/SaveObjectToExcel";
import { AppEntities } from "../../../../config/entities";
import { saveObjectToExcel } from "../../../../helpers/SaveObjectToExcel";
import { SettlementVendorOpeningBalancesDetailMain } from "./SettlementVendorOpeningBalancesDetailMain";
import { SettlementVendorOpeningBalancesDetailSettlement } from "./SettlementVendorOpeningBalancesDetailSettlement";
import { SettlementVendorOpeningBalancesDetailFooter } from "./SettlementVendorOpeningBalancesDetailFooter";
import DocumentDetailViewToolbar from "../../../Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "../../../Shared/DetailViews/DetailViewPostButton";
import DetailViewSaveButton from "../../../Shared/DetailViews/DetailViewSaveButton";
import DetailViewCancelButton from "../../../Shared/DetailViewCancelButton";
import DetailViewToolbarMoreActions from "../../../Shared/DetailViews/DetailViewToolbarMoreActions";

interface IProps {
  model: SettlementVendorOpeningBalancesDto | null;
  modelUpdatedEvent: (newModel: SettlementVendorOpeningBalancesDto) => void;
}

export const SettlementVendorOpeningBalancesDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<SettlementVendorOpeningBalancesModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Stock takings");

  const watchProducts = watch("settlements");

  useEffect(() => {
    // console.log(model);
    register("settlements");
    if (model) {
      setValue("baseDocumentAtId", model.baseDocumentAtId);
      setValue("documentDate", model.documentDate);
      setValue("createdDate", model.createdDate);
      setValue("companyId", model.companyId);
      setValue("pendingChanges", model.pendingChanges);
      setValue("status", model.status);
      setValue("comment", model.comment);
      setValue("settlements", model.settlements);
    }
  }, [model]);

  const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: SettlementVendorOpeningBalancesModel) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };

  if (!model) {
    return <>{/* <StockTakingsDetailSkeleton /> */}</>;
  }

  const exportToExcel = () => {
    const data = {
      ...model
    };
    const documentInfo = {
      title: AppEntities.SettlementVendorOpeningBalances.title,
      number: model.documentNumber,
      date: model.documentDate
    };
    saveObjectToExcel(data, documentInfo);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };
  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Products"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))} />
          <DetailViewSaveButton onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))} />
          <DetailViewCancelButton onCancel={cancelHandler} />
          <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
        </DocumentDetailViewToolbar>

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <SettlementVendorOpeningBalancesDetailMain />
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <SettlementVendorOpeningBalancesDetailSettlement />
        </NFTabContainer>
      </div>
      <SettlementVendorOpeningBalancesDetailFooter />
    </FormProvider>
  );
};
